import { useEffect, useRef } from 'react';
import type { RefObject } from 'react';

export const useResize = ({
  ref,
  callback,
}: {
  ref: RefObject<HTMLElement>;
  callback: () => void;
}): void => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const callback = callbackRef.current;
    const element = ref.current;
    if (!element) {
      return;
    }

    if (typeof MutationObserver === `undefined`) {
      const eventName = `DOMSubtreeModified`;

      document.addEventListener(eventName, callback);
      return () => document.removeEventListener(eventName, callback);
    }

    if (typeof ResizeObserver === `undefined`) {
      const observer = new MutationObserver(callback);
      observer.observe(ref.current, {
        characterData: true,
        attributes: true,
        childList: true,
        subtree: true,
      });

      return () => observer.disconnect();
    }

    console.log(`YES`);

    const observer = new ResizeObserver(callback);

    observer.observe(element);
    return () => observer.unobserve(element);
  }, []);
};
